import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()

export const deleteLead = async (nome_lista: string, cnpj: string) => {
    if (!nome_lista || !cnpj) return false;
    try {
        auth = getAuthState()
        const response = await fetch(`https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/leads?nome_lista=${nome_lista}&cnpj=${cnpj}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            }
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error deleting lead:', error);
        return error;
    }
};